import React, { useEffect } from 'react'
import { useRouteMatch } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import { gtmEvent } from 'lib/gtm'
import AgeGroupChip, { getAgeGroupChipVariant } from 'components/age-group-chip'
import TipWell, { TipWellActionButton } from 'components/tip-well'
import useSettingsStyles from 'pages/pga-coach/settings/settings.styles'
import {
  SettingsLinkRow,
  SettingsSection,
} from 'pages/pga-coach/settings/settings-components'
import SchoolOutlinedIcon from 'components/material-symbol/icons/School'
import CelebrationIcon from 'components/material-symbol/icons/Celebration'
import SportsGolfIcon from 'components/material-symbol/icons/SportsGolf'
import GolfCourseIcon from 'components/material-symbol/icons/GolfCourse'
import TrendingUpIcon from 'components/material-symbol/icons/TrendingUp'
import EmojiEventsIcon from 'components/material-symbol/icons/EmojiEvents'
import StarsIcon from 'components/material-symbol/icons/Stars'
import PeopleAltIcon from 'components/material-symbol/icons/PeopleAlt'
import HeightIcon from 'components/material-symbol/icons/Height'

const COACH_TRAINING_CENTER_URL =
  'https://vt.lightspeedvt.com/share/redirect.cfm?signInURL=https://webservices.lightspeedvt.net/SAML/lsvt/login.aspx?h=auth0.pga.com&dest=https://vt.lightspeedvt.com/trainingCenter/'

const stagesBlocks = [
  {
    link: 'active-start',
    Icon: CelebrationIcon,
    title: 'Active Start',
    tags: ['Girls 0 - 6', 'Boys 0 – 6'],
  },
  {
    link: 'fundamentals',
    Icon: SportsGolfIcon,
    title: 'FUNdamentals',
    tags: ['Girls 6 – 8', 'Boys 6 – 9'],
  },
  {
    link: 'learn-to-play',
    Icon: GolfCourseIcon,
    title: 'Learn to Play',
    tags: ['Girls 8 – 11', 'Boys 9 – 12'],
  },
  {
    link: 'play-to-improve',
    Icon: TrendingUpIcon,
    title: 'Play to Improve',
    tags: ['Girls 11 – 15', 'Boys 12 – 16'],
  },
  {
    link: 'play-to-compete',
    Icon: EmojiEventsIcon,
    title: 'Play to Compete',
    tags: ['Girls 15 – 21', 'Boys 16 – 23'],
  },
  {
    link: 'play-to-win',
    Icon: StarsIcon,
    title: 'Play to Win',
    tags: ['Girls 18+', 'Boys 19+'],
  },
  {
    link: 'play-golf-for-life',
    Icon: PeopleAltIcon,
    title: 'Play Golf for Life',
    tags: ['Adults'],
  },
  {
    link: 'fundamental-movement-skills',
    Icon: HeightIcon,
    title: 'Fundamental Movement Skills',
    tags: ['All Ages'],
  },
]

const ActivityPlans = () => {
  const settingsStyles = useSettingsStyles()
  const { path } = useRouteMatch()

  useEffect(() => {
    gtmEvent({
      event: 'activities-click',
      activitiesCategory: 'coach-activities',
      activitiesAction: 'stages-loaded',
      activitiesLabel: 'stages-loaded',
    })
  }, [])

  const handleStageClick = link => {
    gtmEvent({
      event: 'activities-click',
      activitiesCategory: 'coach-activities',
      activitiesAction: 'stages-click',
      activitiesLabel: link,
    })
  }

  return (
    <Box className={settingsStyles.contentContainer}>
      <TipWell
        icon={SchoolOutlinedIcon}
        caption="Access ADM Training, Becoming a Modern Coach, and more education opportunities in the Coach Training Center."
        action={
          <TipWellActionButton
            href={COACH_TRAINING_CENTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            component="a"
          >
            Open
          </TipWellActionButton>
        }
      />

      <SettingsSection
        eyebrow="ADM stages"
        subtitle="Select a stage to view activities and ADM-aligned lesson plans."
        classes={settingsStyles}
      >
        {stagesBlocks.map(block => {
          const StageIcon = block.Icon

          return (
            <SettingsLinkRow
              key={block.link}
              to={`${path}/${block.link}/activities`}
              onClick={() => handleStageClick(block.link)}
              icon={<StageIcon />}
              iconWrapClassName={settingsStyles.rowIconTinted}
              title={block.title}
              trailing={
                <Box className={settingsStyles.rowTags}>
                  {block.tags.map(tag => (
                    <AgeGroupChip
                      key={tag}
                      label={tag}
                      variant={getAgeGroupChipVariant(tag)}
                    />
                  ))}
                </Box>
              }
              classes={settingsStyles}
            />
          )
        })}
      </SettingsSection>
    </Box>
  )
}

export default ActivityPlans
